<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedStatuses"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Bid status')"
      :list="bidStatuses"
      :placeholder="$t('All bid statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { BidStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const statusLabels: Record<string, string> = {
  [BidStatus.Open]: $t('Open'),
  [BidStatus.Accepted]: $t('Accepted'),
  [BidStatus.Rejected]: $t('Rejected'),
  [BidStatus.Cancelled]: $t('Cancelled'),
}

const orderedStatuses = [
  BidStatus.Open,
  BidStatus.Accepted,
  BidStatus.Rejected,
  BidStatus.Cancelled,
]

const bidStatuses = computed(() =>
  orderedStatuses.map((status) => ({
    label: statusLabels[status] ?? status,
    value: status,
  })),
)
</script>
